import React from 'react';
import styles from '../styles/Global';
import assets from '../assets';

const Download = () => {
	return (
		<div className={`${styles.section} ${styles.bgWhite}`}>
			<div className={`${styles.subSection} flex-col text-center`}>
				<div>
					<h1 className={`${styles.h1Text}`}>
						Download the Source Code
					</h1>
				</div>
				<button
					onClick={() =>
						window.open(
							'https://github.com/vrindavan/proNef',
							'_blank'
						)
					}
					className={styles.btnPrimary}>
					Get it on GitHub
				</button>
				<div className={styles.flexCenter}>
					<img
						src={assets.scene}
						alt='download_png'
						className={styles.fullImg}
					/>
				</div>
			</div>
		</div>
	);
};

export default Download;
